import { Component, Vue } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';
import ArrowSmall from '@/assets/icons/arrow-small.svg?inline';
import GenericComponent from '@/components/GenericComponent/GenericComponent.vue';

import { ContentAccordionBlockViewModel } from './ContentAccordionModule.types';
import Accordion from '@/components/Accordion/Accordion.vue';

const ContentAccordionModuleProps = Vue.extend({
  props: getComponentProps<ContentAccordionBlockViewModel>({
    Title: '',
    Cta: {
      Link: '',
      Title: '',
    },
    Items: [
      {
        Question: 'Question1?',
        AnswerItems: [
          {
            Type: 'ContentAccordionButtonBlock',
            Item: {
              Action: 'Button',
              Title: 'label',
              Link: 'link',
              ButtonStyle: 2,
            },
          },
          {
            Type: 'ContentTextGenericBlock',
            Item: {
              Text: '<p>Test</p>\n<p>text</p>\n<p>html </p>\n<p>as</p>',
              IsDropLetter: false,
            },
          },
          {
            Type: 'ContentAccordionPhoneBlock',
            Item: {
              Action: 'Phone',
              Title: '0312021',
              Link: 'LINK',
              ButtonStyle: 1,
            },
          },
        ],
      },
    ],
    IsLeft: false,
  }),
});

@Component({
  components: {
    GenericComponent,
    ArrowSmall,
    Accordion,
  },
})
export default class ContentAccordionModule extends ContentAccordionModuleProps {}
